const START_APP = 'START_APP';
const ADD_ELEMENT = 'ADD_ELEMENT';
const REMOVE_ELEMENT = 'REMOVE_ELEMENT';

export { START_APP, ADD_ELEMENT, REMOVE_ELEMENT };
